import React, { memo } from 'react'
import { ScrollView, View } from 'react-native'
import { useSelector } from 'react-redux'
import { StyleService, useStyleSheet } from '@src/style/service'
import { MobileAppFeature } from '@src/types'
import { User } from '@src/utils'
import { NutritionSummaryCard } from '@components/NutritionSummaryCard/NutritionSummaryCard'
import { preferredHeroChartSelector } from '@src/selectors/settings'
import { HeroChartType } from '@src/screens/Settings/models/settings.types'
import { GlucoseSummaryCard } from '../GlucoseSummary/GlucoseSummaryCard'
import { GlucoseScoreCard } from '../GlucoseScore/GlucoseScoreCard'
import { NoraVoiceHighlightCard } from './NoraVoiceHighlightCard'

export const HighlightsSection = memo(() => {
  const styles = useStyleSheet(themedStyles)
  const hasGlucoseInsights = User.hasFeature(MobileAppFeature.GlucoseInsights)
  const heroChart = useSelector(preferredHeroChartSelector)
  const showNutritionSummaryCard = heroChart !== HeroChartType.NutritionSummaryChart

  if (!hasGlucoseInsights && showNutritionSummaryCard) {
    return (
      <View style={styles.singleCardContainer}>
        <NoraVoiceHighlightCard />
        <NutritionSummaryCard />
      </View>
    )
  }

  return (
    <ScrollView
      style={styles.container}
      contentContainerStyle={styles.contentContainer}
      horizontal
      showsHorizontalScrollIndicator={false}
    >
      <NoraVoiceHighlightCard />
      <GlucoseSummaryCard />
      <GlucoseScoreCard />

      {showNutritionSummaryCard && <NutritionSummaryCard />}
    </ScrollView>
  )
})

const themedStyles = StyleService.create({
  container: {
    marginTop: 8,
    height: 136,
  },
  singleCardContainer: {
    marginTop: 8,
    paddingHorizontal: 16,
    flexDirection: 'row',
    gap: 8,
  },
  contentContainer: {
    flexDirection: 'row',
    marginRight: 8,
    paddingHorizontal: 16,
    gap: 8,
  },
})
